<template>
    <div class="message_files mt-2">
        <div class="file_list_item" v-for="(item, index) in message.attachments" :key="index">
            <div class="res_img_wrapper cursor-pointer" @click="$store.commit('chat/SET_SELECT_IMG', item)" v-if="item.is_image">
                <img class="img_resp lazyload" :data-src="item.path" :alt="item.name" />
            </div>
            <div class="file_wrapper audio" v-else>
                <template v-if="checkAudio(item)">
                    <audio controls class="w-full">
                        <source :src="item.file" type="audio/mpeg">
                    </audio>
                </template>
                <template v-else>
                    <!-- flex item-center truncate -->
                    <a class="doc_file_message" download :href="item.path">
                        <feather-icon class="mr-2" icon="DownloadIcon" svgClasses="w-4 h-4" />
                        {{item.name}}
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {checkNameType} from './utils'
export default {
    props: {
        message: Object
    },
    methods: {
        type(file) {
            return checkNameType(file)
        },
        checkAudio(file) {
            if(file.name.split('.')[1] === 'mp3')
                return true
            else
                return false
        },
        linkReplace(file) {
            if(file.indexOf('acc.gos24.kz') !== -1)
                return file
            else
                return 'https://acc.gos24.kz' + file
        }
    }
}
</script>

<style lang="scss">
.doc_file_message{
    display: block;
    word-break: break-word;
}
.file_list_item{
    &:not(:last-child){
        margin-bottom: 8px;
    }
}
.res_img_wrapper{
    width: 180px;
    height: 180px;
    overflow: hidden;
    display: flex;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    img{
        object-fit: cover;
        vertical-align: middle;
        -o-object-fit: cover;
    }
}
.img_resp{
    max-width: 100%;
}
.file_wrapper{
    a{
        color: #ffffff;
        background: black;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        padding: 8px 10px;
        .feather-icon{
            float: left;
        }
    }
    &.audio{
        max-width: 220px;
    }
}
.bg_white{
    .file_wrapper{
        a{
            color: #626262;
        }
    }
}
</style>
